import { __assign, __rest } from "tslib";
import React from 'react';
import { RicosViewer } from 'ricos-viewer';
import { runStrategies, extractPluginsConfig, fetchEmbedData, themeStrategy, experimentStrategy, } from '@wix/ricos-common';
import { merge } from 'lodash';
import { runViewerStrategies } from './runViewerStrategies';
var WixRicosViewer = function (props) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    var wixRicosVersion = require('../../package.json').version;
    var children = props.children, biSettings = props.biSettings, instance = props.instance, plugins = props.plugins, theme = props.theme, wixExperiments = props.wixExperiments, allowLinkPreviewPopover = props.allowLinkPreviewPopover, httpClient = props.httpClient, msid = props.msid, baseUrl = props.baseUrl, previewMode = props.previewMode, content = props.content, rest = __rest(props, ["children", "biSettings", "instance", "plugins", "theme", "wixExperiments", "allowLinkPreviewPopover", "httpClient", "msid", "baseUrl", "previewMode", "content"]);
    var experiments = experimentStrategy(wixExperiments);
    var strategyProps = runStrategies({
        plugins: plugins,
        instance: instance,
        biSettings: biSettings,
        experiments: experiments,
        wixRicosVersion: wixRicosVersion,
        httpClient: httpClient,
        msid: msid,
        viewer: true,
        content: content,
    });
    var _rcProps = merge(strategyProps, runViewerStrategies(plugins, baseUrl, previewMode), extractPluginsConfig(plugins, strategyProps.helpers));
    return (React.createElement(RicosViewer, __assign({ _rcProps: _rcProps, content: content, experiments: _rcProps.experiments, plugins: plugins, theme: themeStrategy(theme) }, (allowLinkPreviewPopover && {
        linkPreviewPopoverFetchData: fetchEmbedData(instance),
    }), rest), children));
};
export default WixRicosViewer;
//# sourceMappingURL=WixRicosViewer.js.map